import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '网红黑料', href: '/category/wanghong-heiliao' },
  { label: '明星聊天记录', href: '/category/mingxing-liaotian' },
  { label: '博主私下爆料', href: '/category/bozhu-baoliao' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`text-2xl font-black tracking-tight transition-colors duration-300 ${
              isScrolled ? 'text-primary-600' : 'text-background-50'
            }`}>
              911
            </span>
            <span className={`text-sm font-medium transition-colors duration-300 ${
              isScrolled ? 'text-foreground-700' : 'text-background-50/80'
            }`}>
              爆料网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-primary-500 ${
                  location.pathname === link.href
                    ? isScrolled ? 'text-primary-600' : 'text-primary-300'
                    : isScrolled ? 'text-foreground-700' : 'text-background-50/80'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`px-5 py-2 text-sm font-semibold whitespace-nowrap rounded-full transition-all duration-300 cursor-pointer ${
                isScrolled
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50/15 text-background-50 hover:bg-background-50/25 border border-background-50/20'
              }`}
            >
              下载APP
            </Link>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors duration-300 ${
              isScrolled ? 'text-foreground-800' : 'text-background-50'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors duration-200 ${
                  location.pathname === link.href
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="mt-1 px-5 py-2.5 text-sm font-semibold text-center whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              下载APP
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}